import {
	Box,
	Button,
	Card,
	CardActions,
	CardContent,
	CardHeader,
	Divider,
	IconButton,
	List,
	ListItem,
	Stack,
	Typography,
} from '@mui/material';
import { ArrowSquareOut } from '@phosphor-icons/react/dist/ssr/ArrowSquareOut';
import dayjs from 'dayjs';
import { FC } from 'react';

const maps = [
	{
		id: '1',
		title: 'Meth labs',
	},
	{
		id: '2',
		title: 'Sydney 2000 olympic venues',
	},
	{
		id: '3',
		title: 'Terrible coffee shops',
	},
	{
		id: '4',
		title: 'Terrific coffee shops',
	},
	{
		id: '5',
		title: 'New places to dig tunnels',
	},
];

const mockDate = new Date(2000, 1, 1);

export const DatasetInfo: FC = () => {
	return (
		<Card>
			<CardHeader
				title={
					<Typography variant="h6">sydney_address_pt2 ORIGINAL</Typography>
				}
			/>
			<CardContent>
				<Stack spacing={2}>
					<Stack spacing={2}>
						<Typography variant="body2" gutterBottom>
							This is some description about the dataset. It features some
							information about the dataset, such as the number of rows,
							columns, and the date it was last updated.
						</Typography>
						<Typography variant="body2">
							Source: Sydney Retails Network Database Attribution: Data provided
							by Sydney Chamber of Commerce, &copy; 2024 Sydney Chamber of
							Commerce.
						</Typography>
					</Stack>
					<Divider />
					<List
						sx={{
							'& .MuiListItem-root': {
								justifyContent: 'space-between',
								px: 0,
							},
						}}
					>
						<ListItem>
							<Typography variant="subtitle2">Type</Typography>
							<Typography color="text.secondary" variant="body2">
								Point
							</Typography>
						</ListItem>
						<ListItem>
							<Typography variant="subtitle2">Data sync</Typography>
							<Typography color="text.secondary" variant="body2">
								Active
							</Typography>
						</ListItem>
						<ListItem>
							<Typography variant="subtitle2">Created</Typography>
							<Typography color="text.secondary" variant="body2">
								{dayjs(mockDate).format('YYYY-MM-DD HH:mm:ss')}
							</Typography>
						</ListItem>
						<ListItem>
							<Typography variant="subtitle2">Updated</Typography>
							<Typography color="text.secondary" variant="body2">
								{dayjs(mockDate)
									.subtract(1, 'day')
									.format('YYYY-MM-DD HH:mm:ss')}
							</Typography>
						</ListItem>
					</List>
					<Divider />
					<Typography variant="subtitle2">Maps using this data</Typography>
					<Stack component="ul" sx={{ listStyle: 'none', m: 0, p: 0 }}>
						{maps.map((item) => (
							<MapItem {...item} key={item.id} />
						))}
					</Stack>
				</Stack>
			</CardContent>
			<Divider />
			<CardActions
				sx={{ justifyContent: 'flex-end', alignItems: 'center', spacing: 1 }}
			>
				<Typography variant="body2">Download</Typography>
				<Button href="#" target="_blank">
					SHP
				</Button>
				<Button href="#" target="_blank">
					CSV
				</Button>
				<Button href="#" target="_blank">
					KML
				</Button>
			</CardActions>
		</Card>
	);
};

const MapItem: FC<{ title }> = ({ title }) => {
	return (
		<Box component="li" sx={{ userSelect: 'none' }}>
			<Box
				role="button"
				sx={{
					alignItems: 'center',
					borderRadius: 1,
					color: 'var(--mui-palette-text-secondary)',
					cursor: 'pointer',
					display: 'flex',
					flex: '0 0 auto',
					gap: 1,
					p: '6px 0px',
					textDecoration: 'none',
					whiteSpace: 'nowrap',
					'&:hover': {
						bgcolor: 'var(--mui-palette-action-hover)',
						color: 'var(---mui-palette-text-primary)',
					},
				}}
				tabIndex={0}
			>
				<Box sx={{ flex: '1 1 auto' }}>
					<Typography
						component="span"
						sx={{
							color: 'inherit',
							fontSize: '0.875rem',
							fontWeight: 500,
							lineHeight: '28px',
						}}
					>
						{title}
					</Typography>
				</Box>
				<IconButton href="#" target="_blank">
					<ArrowSquareOut />
				</IconButton>
			</Box>
		</Box>
	);
};
